document.addEventListener("DOMContentLoaded", function () {
  // This file is loaded on every page of the theme, so bail out unless the
  // Before & After gallery is actually present.
  const productsDropdown = document.querySelector('.dropdown-list[data-select="products"]');
  if (!productsDropdown) return;

  const itemsPerPage = 12;
  const paginationContainer = document.getElementById("pagination-container");
  let currentPage = 1;

  // --- Elements for the new disabling function ---
  const productsDropdownWrapper = productsDropdown.closest('.custom-select');
  const productsSelectedDisplay = productsDropdownWrapper.querySelector('.selected');

  // Default "All Products" label. There is no all-products <li>, so fall back to
  // the placeholder the Liquid snippet renders - that one is already localised.
  const allProductsItem = productsDropdownWrapper.querySelector('li[data-value="all-products"]');
  const allProductsText = allProductsItem
    ? allProductsItem.querySelector('.option-title').innerText
    : (productsSelectedDisplay.dataset.placeholder || 'All Products');
  // --------------------------------------------------

  // Collection grouping is read off the DOM instead of being hardcoded here:
  // every product <li> carries data-value (= the product handle, which matches
  // data-category on the result items) and data-group (= the collection handle).
  // Adding a product means adding an <li> in the snippet - no JS change needed.
  const productHandlesByGroup = {}; // group -> [product handles]
  const menuValuesByGroup = {};     // group -> [every data-value, incl. all-*]
  productsDropdown.querySelectorAll('li[data-group]').forEach(li => {
    const group = li.getAttribute('data-group');
    const value = li.getAttribute('data-value');
    if (!group || !value) return;
    (menuValuesByGroup[group] = menuValuesByGroup[group] || []).push(value);
    if (value.indexOf('all-') !== 0) {
      (productHandlesByGroup[group] = productHandlesByGroup[group] || []).push(value);
    }
  });
  const allMenuValues = Object.keys(menuValuesByGroup)
    .reduce((acc, g) => acc.concat(menuValuesByGroup[g]), []);

  // "All ..." entries mean "do not narrow down to a single product"
  const isAllValue = value => !value || value === 'all' || value.indexOf('all-') === 0;

  function getVisibleItems() {
    return Array.from(document.querySelectorAll(".paginate:not(.hide)"));
  }

  function showPage(page) {
    currentPage = page;
    const visibleItems = getVisibleItems();
    const start = (page - 1) * itemsPerPage;
    const end = start + itemsPerPage;

    // Hide all items first
    document.querySelectorAll(".paginate").forEach(item => {
      item.style.display = "none";
    });

    // Show visible items for this page
    visibleItems.forEach((item, index) => {
      if (index >= start && index < end) {
        item.style.display = "block";
      }
    });

    renderPaginationControls(visibleItems.length);
  }

  // --- UPDATED PAGINATION WITH TRUNCATION LOGIC ---
  function renderPaginationControls(totalVisible) {
    paginationContainer.innerHTML = "";
    const totalPages = Math.ceil(totalVisible / itemsPerPage);

    if (totalPages <= 1) return;

    // Prev button
    const prevBtn = document.createElement("button");
    prevBtn.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0300/6637/6788/files/Component_1.png?v=1758516497">';
    prevBtn.disabled = currentPage === 1;
    prevBtn.addEventListener("click", () => showPage(currentPage - 1));
    paginationContainer.appendChild(prevBtn);

    // Pagination Number Logic
    const range = 1; // Number of pages to show around current page
    let pages = [];

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - range && i <= currentPage + range)) {
        pages.push(i);
      }
    }

    let l;
    for (let i of pages) {
      if (l) {
        if (i - l === 2) {
          addPageButton(l + 1);
        } else if (i - l !== 1) {
          const ellipsis = document.createElement("span");
          ellipsis.innerText = "...";
          ellipsis.className = "pagination-dots";
          paginationContainer.appendChild(ellipsis);
        }
      }
      addPageButton(i);
      l = i;
    }

    function addPageButton(i) {
      const btn = document.createElement("button");
      btn.innerText = i;
      btn.className = (i === currentPage) ? "active" : "";
      btn.addEventListener("click", () => showPage(i));
      paginationContainer.appendChild(btn);
    }

    // Next button
    const nextBtn = document.createElement("button");
    nextBtn.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0300/6637/6788/files/Vector.png?v=1758512062">';
    nextBtn.disabled = currentPage === totalPages;
    nextBtn.addEventListener("click", () => showPage(currentPage + 1));
    paginationContainer.appendChild(nextBtn);
  }

  function refreshPagination() {
    showPage(1);
  }

  // ------------------------------------
  // DROPDOWN FILTER SCRIPT (Maintained)
  // ------------------------------------
  const selectedValues = {
    collections: null,
    products: null,
    cups: null,
  };

  const imageItem = document.querySelectorAll('.content-sizing-area__result-item');

  function resetCollection() {
    imageItem.forEach(item => {
      item.classList.remove('hide', 'selected');
    });
  }

  function resetProductDropdownToAll() {
    selectedValues.products = null;
    productsSelectedDisplay.innerHTML = `<span>${allProductsText}</span>`;
    productsDropdownWrapper.querySelectorAll('li').forEach(item => {
      item.classList.remove('active');
      item.querySelector('.radio-circle')?.classList.remove('active');
    });
    if (allProductsItem) {
      allProductsItem.classList.add('active');
      allProductsItem.querySelector('.radio-circle')?.classList.add('active');
    }
  }

  function toggleProductDropdownState(shouldDisable) {
    if (shouldDisable) {
      productsDropdownWrapper.classList.add('disabled');
      productsSelectedDisplay.style.pointerEvents = 'none';
      resetProductDropdownToAll();
    } else {
      productsDropdownWrapper.classList.remove('disabled');
      productsSelectedDisplay.style.pointerEvents = '';
    }
    applyFilters();
  }

  function updateAvailableCups() {
    const { collections, products } = selectedValues;
    const availableSizes = new Set();

    imageItem.forEach(item => {
      const category = item.getAttribute('data-category');
      const size = item.getAttribute('data-size');
      let show = true;

      if (collections && collections !== 'all-collections') {
        show = (productHandlesByGroup[collections] || []).includes(category);
      }

      if (show && !isAllValue(products)) show = category === products;

      if (collections === 'all-collections' && products) show = true;
      if (show && size) availableSizes.add(size);
    });

    const cupDropdown = document.querySelector('.dropdown-list[data-select="cups"]');
    if (cupDropdown) {
      cupDropdown.querySelectorAll('li').forEach(li => {
        const cupVal = li.getAttribute('data-value');
        if (cupVal === 'all') {
          li.classList.remove('disabled');
          li.style.pointerEvents = ""; li.style.opacity = "1";
          return;
        }
        if (!availableSizes.has(cupVal)) {
          li.classList.add('disabled'); li.style.pointerEvents = "none";
          li.style.opacity = "0.5"; li.style.color = "#d4d4d4";
        } else {
          li.classList.remove('disabled'); li.style.pointerEvents = "";
          li.style.opacity = "1"; li.style.color = "#222";
        }
      });
    }
  }

  function applyFilters() {
    resetCollection();
    const { collections, products, cups } = selectedValues;
    let hasMatch = false;
    updateAvailableCups();

    imageItem.forEach(item => {
      const category = item.getAttribute('data-category');
      const categorySize = item.getAttribute('data-size');
      let show = true;

      if (collections && collections !== 'all-collections') {
        show = (productHandlesByGroup[collections] || []).includes(category);
      }

      if (show && collections !== 'all-collections' && !isAllValue(products)) {
        show = category === products;
      }

      if (show && cups && cups !== 'all') show = categorySize === cups;

      if (show) {
        item.classList.remove('hide'); item.classList.add('selected');
        hasMatch = true;
      } else {
        item.classList.add('hide'); item.classList.remove('selected');
      }
    });

    const noResultEl = document.querySelector('.no-results-message');
    if (noResultEl) noResultEl.style.display = hasMatch ? 'none' : 'block';
    refreshPagination();
  }

  document.querySelectorAll('.custom-select').forEach(selectBox => {
    const selected = selectBox.querySelector('.selected');
    const dropdownTypes = ['collections', 'products', 'cups'];

    selected.addEventListener('click', () => {
      if (selectBox.classList.contains('disabled')) return;
      document.querySelectorAll('.custom-select').forEach(otherBox => {
        if (otherBox !== selectBox) otherBox.classList.remove('open');
      });
      selectBox.classList.toggle('open');
    });

    dropdownTypes.forEach(type => {
      const dropdown = selectBox.querySelector(`.dropdown-list[data-select="${type}"]`);
      if (!dropdown) return;
      dropdown.querySelectorAll('li').forEach(item => {
        item.addEventListener('click', () => {
          if (item.classList.contains('disabled')) return;
          const value = item.getAttribute('data-value');
          const title = item.querySelector('.option-title')?.innerText || '';
          selectedValues[type] = value;

          if (type === 'collections') {
            const isAllCollections = value === 'all-collections';
            toggleProductDropdownState(isAllCollections);
            const productItems = productsDropdown.querySelectorAll('li');
            const validList = menuValuesByGroup[value] || allMenuValues;
            productItems.forEach(productItem => {
              productItem.classList.remove('hide');
              const pVal = productItem.getAttribute('data-value');
              if (validList.length && !validList.includes(pVal)) productItem.classList.add('hide');
            });
          }

          selectBox.querySelectorAll('li').forEach(i => {
            i.classList.remove('active'); i.querySelector('.radio-circle')?.classList.remove('active');
          });
          item.classList.add('active'); item.querySelector('.radio-circle')?.classList.add('active');
          selected.innerHTML = `<span>${title}</span>`;
          applyFilters();
          selectBox.classList.remove('open');
        });
      });
    });
  });

  document.addEventListener('click', e => {
    document.querySelectorAll('.custom-select').forEach(box => {
      if (!box.contains(e.target)) box.classList.remove('open');
    });
  });

  document.querySelector('.reset-btn')?.addEventListener('click', () => {
    selectedValues.collections = null; selectedValues.products = null; selectedValues.cups = null;
    const allColl = document.querySelector('li[data-value="all-collections"]');
    if (allColl) selectedValues.collections = allColl.getAttribute('data-value');

    document.querySelectorAll('.custom-select').forEach(selectBox => {
      const selected = selectBox.querySelector('.selected');
      const defaultText = selected.getAttribute('data-placeholder') || 'Select';
      const selectType = selectBox.querySelector('.dropdown-list').getAttribute('data-select');
      selected.innerHTML = `<span>${defaultText}</span>`;
      selectBox.querySelectorAll('li').forEach(item => {
        item.classList.remove('active', 'hide');
        item.querySelector('.radio-circle')?.classList.remove('active');
      });
      let def;
      if (selectType === 'collections') def = selectBox.querySelector('li[data-value="all-collections"]');
      else if (selectType === 'products') def = selectBox.querySelector('li[data-value="all-products"]');
      else if (selectType === 'cups') def = selectBox.querySelector('li[data-value="all"]');
      if (def) { def.classList.add('active'); def.querySelector('.radio-circle')?.classList.add('active'); }
    });

    ['all-inserts', 'all-bras', 'all-tapes'].forEach(val => document.querySelector(`li[data-value="${val}"]`)?.classList.add('hide'));
    toggleProductDropdownState(true);
    applyFilters();
  });

  // Initial Load
  showPage(1);
  updateAvailableCups();
  if (document.querySelector('li[data-value="all-collections"]')?.classList.contains('active')) {
    toggleProductDropdownState(true);
  }
});